const routes = [
  {
    path: ["/"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/about"],
    exact: true,
    component: "About",
  },
  {
    path: ["/products"],
    exact: true,
    component: "Products",
  },
  {
    path: ["/services"],
    exact: true,
    component: "Services",
  },
  {
    path: ["/services/:slug"],
    exact: true,
    component: "ServiceLanding",
  },
  {
    path: ["/technology"],
    exact: true,
    component: "Technology",
  },
  {
    path: ["/solar-calculator"],
    exact: true,
    component: "SolarCalucator",
  },
  {
    path: ["/case-studies"],
    exact: true,
    component: "CaseStudies",
  },
  {
    path: ["/contact"],
    exact: true,
    component: "ContactPage",
  },
  {
    path: ["/404"],
    exact: true,
    component: "NotFound",
  },
   {
    path: ["/admin-login"],
    exact: true,
    component: "Admin/AdminLogin",
  },
];

export default routes;
